import React, { useState, useEffect } from 'react';
import { COLORS, FONTS } from '../shared/ContentData';
import { ChatbotService } from "../../services/ChatbotService";
const chatbotService = new ChatbotService();

const FestivalChatbot = ({ isMobile, isPlayMode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Meowzit! I'm the Search Festival catbot, your jollification spirit guide. How can I help?", sender: 'bot' }
  ]);
  const [userInput, setUserInput] = useState('');

  const handleSendMessage = async () => {
    if (userInput.trim() && !isPlayMode) {
      // Add user message
      const userMessage = { text: userInput, sender: 'user' };
      setMessages(prev => [...prev, userMessage]);
      
      // Get bot response from Supabase
      const botResponse = await chatbotService.getResponse(userInput);
      
      // Add bot response with a slight delay
      setTimeout(() => {
        setMessages(prev => [...prev, botResponse]);
      }, 500);
      
      setUserInput('');
    }
  };

   // Adjust mascot visibility based on play mode
   useEffect(() => {
    console.log('FestivalChatbot mounted');
    if (isPlayMode) {
      setIsOpen(false);
    }
  }, [isPlayMode]);
  
  const renderMascot = () => {
    // Only render if not in play mode
    if (isPlayMode) return null;

    return (
      <div style={{ 
        width: isMobile ? '60px' : '80px',
        height: isMobile ? '60px' : '80px',
        cursor: 'pointer',
        transition: 'transform 0.3s',
        transform: isOpen ? 'scale(1.1)' : 'scale(1)',
        borderRadius: '50%',
        overflow: 'hidden'
      }}>
        <img 
          src="chatbot-mascot.png"
          alt="Chatbot Mascot"
          style={{ 
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
    );
  };

  const renderChatInterface = () => {
    if (isPlayMode) return null;

    return (
      <div style={{
        position: 'fixed',
        bottom: isMobile ? '90px' : '100px',
        right: isMobile ? '20px' : '20px',
        width: isMobile ? '90vw' : '300px',
        maxWidth: '400px',
        backgroundColor: COLORS.content,
        borderRadius: '15px',
        padding: '15px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        fontFamily: FONTS.primary,
        zIndex: 1000,
        maxHeight: '500px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{ 
          height: '300px', 
          overflowY: 'auto',
          marginBottom: '15px',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {messages.map((msg, index) => (
            <div 
              key={index} 
              style={{
                alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                backgroundColor: msg.sender === 'user' ? COLORS.boid : '#f0f0f0',
                color: msg.sender === 'user' ? 'white' : 'black',
                padding: '10px',
                borderRadius: '10px',
                margin: '5px 0',
                maxWidth: '80%',
                wordWrap: 'break-word'
              }}
            >
              {msg.text}
            </div>
          ))}
        </div>
        <div style={{ display: 'flex' }}>
          <input 
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: '10px',
              border: '1px solid #ddd',
              fontFamily: FONTS.primary
            }}
            placeholder="Ask about the festival..."
          />
          <button 
            onClick={handleSendMessage}
            style={{
              marginLeft: '10px',
              padding: '10px',
              borderRadius: '10px',
              backgroundColor: COLORS.boid,
              color: 'white',
              border: 'none',
              fontFamily: FONTS.primary
            }}
          >
            Send
          </button>
        </div>
      </div>
    );
  };

  return (
    <div style={{
      position: 'fixed', 
      bottom: '20px', 
      right: '20px', 
      zIndex: 1000
    }}>
      {renderMascot()}
      {isOpen && renderChatInterface()}
    </div>
  );
};

export default FestivalChatbot;